export const TYPE_FORM: Array<string> = [
  'DETAIL',
  'EDIT',
  'NEW'
];

export const CLASS_INPUT = [
  'form-control-plaintext',
  'form-control'
];

export const TYPE_NOTIFY: Array<string> = [
  'INVITATION_USER',
  'UPDATE_USER',
  'FORGET_PASSWORD',
  'CHANGE_PASSWORD'
];

export const STATE_USER: Array<string> = [
  'HABILITADO',
  'DESHABILITADO',
  'PORCOMPLETAR'
];

export const TOOLTIPS = {
  users: {
    labels: {
      entity: 'Institución a la que pertenece el usuario.'
    },
    states: {
      HABILITADO: 'Usuario activo dentro de la aplicación.',
      DESHABILITADO: 'Usuario inactivo dentro de la aplicación.',
      PORCOMPLETAR: 'Usuario invitado, en espera por completar su perfil.',
    }
  },
  certificates: {
    labels: {
      longNameOEA: 'Nombre oficial o legal de la empresa',
      shortNameOEA: 'Nombre corto de la empresa',
      tin: 'Número de Identificación del Operador',
      certificationDate: 'Fecha efectiva de la autorización',
      validityDate: 'Fecha de vencimiento de la autorización',
      industryType: 'Área de negocio o actividad productiva del OEA'
    },
    states: {
      PORREVISION: 'Operador a la espera de autorización.',
      CERTIFICADO: 'Operador Económico Autorizado.',
      RECHAZADO: 'Operador que requiere corrección en el registro.',
      SUSPENDIDO: 'Operador suspendido por incidente de seguridad o por incumplimiento de requisitos.',
      EXPIRADO: 'Operador vencido que requiere la desactivación de los beneficios ARM.',
      RETIRADO: 'Operador retirado que requiere la desactivación de los beneficios ARM.',
      CANCELADO: 'Operador cancelado que requiere la desactivación de los beneficios ARM.'
    },
    accredited: {
      ACCREDITED: 'Credencial acreditada en la blockchain',
      NO_EXISTS: 'Credencial no acreditada en la blockchain',
      REVOKED: 'Credencial acreditada en la blockchain como: '

    }
  }
};
